<template>
  <section>
    <b-img fluid center :src="lecturer.photo.url" v-if="lecturer.photo"></b-img>
    <p><strong>{{ $t('lecturer.detail.label.name') }} : </strong>{{ lecturer.lecr_full_name }}</p>
    <p v-if="lecturer.intro">
      <strong>{{ $t('lecturer.detail.label.introduction') }} : </strong><br>
      <span v-html="lecturer.intro"></span>
    </p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
  </section>
</template>

<script>
import Vue from 'vue'

import { ImagePlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

Vue.use(ImagePlugin)

export default {
  i18n,
  name: 'lecturer-info',
  props: {
    lecturer: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      // 
    }
  },
  computed: {
    social_sharing_title() {
      return this.lecturer.lecr_full_name
    },
    social_sharing_route() {
      return { name: 'lecturer', params: { id: this.lecturer.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.lecturer && this.lecturer.id) {
      gtag('event', `browse lecturer`, {
        code: this.lecturer.id,
        name: this.lecturer.lecr_full_name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }
}
</script>